import {Period} from '../../common/model/period.model';
import {EntitaOrganizzativa} from '../entitaorganizzativa/entitaorganizzativa.model';
import {Ruolo} from '../../+configurazione/ruolo/ruolo.model';
import {Persona} from '../persona/persona.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {Helpers} from '../../common/helpers/helpers';
import { StatoRuoloPersona } from './statoruolopersona.enum';

export class RuoloPersona extends Period {

  constructor(protected id: number,
                public persona: Persona,
                public ruolo: Ruolo,
                public entitaOrganizzativa: EntitaOrganizzativa,
                public note: string,
                public provvedimento: string,
                public inizioValidita: string,
                public fineValidita: string,
                public personaDelegante: Persona,
                public delega: boolean,
                public indennita: boolean,
                public importoIndennita: number,
                public soal: boolean,
                public stato: StatoRuoloPersona,
                public dataConsolidamento: string
              ) {
    super(id, inizioValidita, fineValidita);
  }

  public static getTableKeys() {
    return ['persona', 'entitaorganizzativa', 'ruolo', 'contesti', 'stato', "dataConsolidamento", 'Inizio', 'Fine'];
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('persona', new TableRowValue(this.persona.getLabel(), null));
    rowValues.set('entitaorganizzativa', new TableRowValue(this.entitaOrganizzativa ? this.entitaOrganizzativa.getLabel() : null, null));
    rowValues.set('ruolo', new TableRowValue(this.ruolo.getLabel(), null));
    rowValues.set('contesti', new TableRowValue(this.ruolo.getContesti(), null));
    rowValues.set('stato', new TableRowValue(this.stato.getLabelValue(), null, true));
    rowValues.set('dataConsolidamento', new TableRowValue(Helpers.formatDateView(this.getDataConsolidamento()), null));
    rowValues.set('Inizio', new TableRowValue(Helpers.formatDateView(this.getInizio()), null));
    rowValues.set('Fine', new TableRowValue(Helpers.formatDateView(this.getFine()), null));
    rowValues.set('personaDelegante', new TableRowValue(this.personaDelegante ? this.personaDelegante.getLabel(): null, null));
    return new TableRow(this, rowValues);
  }

  public getLabel() {
    let label = 'Assegnazione ' + this.ruolo.getLabel() + ' - ' + this.persona.getLabel();
    if (this.entitaOrganizzativa) {
      label = label + ' - ' + this.entitaOrganizzativa.getLabel();
    }
    return label;
  }

  getDataConsolidamento() {
    if (this.dataConsolidamento) {
      const date = new Date(this.dataConsolidamento);
      date.setHours(0, 0, 0, 0);
      return date;
    }
    return null;
  }
}

